import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Login";
import Home from "./Home";
import Navbar from "./Navbar";
import Users from "./Users";
import UserMaintenance from "./UserMaintenance";
import Roles from "./Roles";
import RoleMaintenance from "./RoleMaintenance";
import GeneratePassword from "./GeneratePassword";
import UploadAddressCheckOne from "./UploadAddressCheckOne";
import ManualAllocateToTl from "./ManualAllocateToFeTl";
import ManualAllocateToFe from "./ManualAllocateToFe";
import AddressCheckOne from "./AddressCheckOne";
import UploadChecks from "./UploadChecks";
import ManualAllocationOfChecksToFeTl from "./ManualAllocationOfChecksToFeTl";
import ManualAllocationOfChecksToFe from "./ManualAllocationOfChecksToFe";
import Meetings from "./Meetings";
import MaintainMeeting from "./MaintainMeeting";
import InviteeJoinPage from "./InviteeJoinPage";
import MeetingRoom from "./MeetingRoom";
import CheckDetailsNewComponent from "./CheckDetailsNewComponent";
import ManualAllocationOFchecksToFeTlNew from "./ManualAllocationOfChecksToFeTlNew";
import MeetingRequests from "./MeetingRequests";
import MeetingRequest from "./MeetingRequest";
import InviteeMeetingResponse from "./InviteeMeetingResponse";
import BankVerificationAllocationToAssociate from "./BankVerificationAllocationToAssociate";
import BankVerificationImport from "./BankVerificationImport";
import BankVerificationAllocatedToAssociate from "./BankVerificationAllocatedToAssociate";
import BankVerificationCaseDetails from "./BankVerificationCaseDetails";
import OAuth2Callback from "./OAuth2Callback";

function App() {
  return(
  <Router>
    <Navbar />
  <Routes>
    <Route path="/" element={<Login />} />
    <Route path="/home" element={<Home />} />
    <Route path="/users" element={<Users />} />
    <Route path="/usermaintenance" element={<UserMaintenance />} />
    <Route path="/usermaintenance/:userId" element={<UserMaintenance />} />
    <Route path="/roles" element={<Roles />} />
    <Route path="/rolemaintenance" element={< RoleMaintenance />} />
    <Route path="/rolemaintenance/:roleId" element={< RoleMaintenance />} />    
    <Route path="/generatepassword" element={<GeneratePassword />} />
    <Route path="/uploadaddresscheckone" element={<UploadAddressCheckOne />} />
    <Route path="/manualallocatetofetl" element={<ManualAllocateToTl />}/>
    <Route path="/manualallocatetofe" element={<ManualAllocateToFe />} />
    <Route path="/addresscheckonedetails" element={<AddressCheckOne />} />
    <Route path="/uploadchecks" element={ <UploadChecks />} />
    <Route path="/manuallyallocatecheckstofetl" element={<ManualAllocationOfChecksToFeTl />} />
    <Route path="/manuallyallocatecheckstofe" element={<ManualAllocationOfChecksToFe />} />    
    <Route path="/meetings" element={<Meetings />} />
    <Route path="/createmeeting" element={<MaintainMeeting />} />
    <Route path="/join-meeting" element = {<InviteeJoinPage />} />
    <Route path="/meetingroom" element={<MeetingRoom />} />
    <Route path="/meetingroom/:roomId/:meetingId" element={<MeetingRoom />} />
    <Route path="/meetingrequests" element={<MeetingRequests />} />
    <Route path="/createmeetingrequest" element={<MeetingRequest />} />
    <Route path="/editmeetingrequest/:id" element={<MeetingRequest />} />
    <Route path="/checkdetails" element={<CheckDetailsNewComponent />} />
    <Route path="/manuallyallocatecheckstofenew" element={<ManualAllocationOFchecksToFeTlNew />} />
    <Route path="/invite/:id" element={<InviteeMeetingResponse />} />    
    <Route path="/bankverificationimport" element={<BankVerificationImport />} />        
    <Route path="/bankverificationallocationtoassociate" element={<BankVerificationAllocationToAssociate />} />    
    <Route path="/bankverificationallocatedtoassociate" element={<BankVerificationAllocatedToAssociate />} />
    <Route path="/bankverificationcasedetails/:caseId" element={<BankVerificationCaseDetails />} />    
    <Route path="/oauth2callback" element={<OAuth2Callback />} />
  </Routes>
</Router>)
}

export default App;
